// src/pages/common/COM301F1.jsx
import React from 'react';

import style from './MCB101F1.module.scss'


const MCB601F1 = ({navBar: NavBar}) => {

    return(
        <main className={style.content}>
            <NavBar>
                {/*Nav 내용*/}
            </NavBar>
            MCB601F1
        </main>
    )
}
export default MCB601F1;
